(function () {
    'use strict';

    a3_cabin_reports.directive('showerrormessage', showerrormessage);

   /**
   * @ngdoc directive
   * @name showerrormessage
   * @restrict EA
   * @description
   *   Implementation of show error message
   * @attr {String} message: the error message.
   * @example
   *   Usage:
   *   <showerrormessage message="No internet access.."></showerrormessage>
   * @ngInject
   */    
    function showerrormessage() {

        function link($scope, element, attrs) {
            $scope.errorMessage = attrs.message;
            $scope.hasMessage = attrs.message != null && attrs.message.length > 0;

        }

        return {
            restrict: 'E',
            template: '<div class="bs-callout border-left-red col-xs-offset-1" ng-if="hasMessage">  <i class="fa fa-warning"></i> {{errorMessage}} </div>',
            scope: false,
            link: link
        }
    }

})();   